import { GetOnfidoCheck } from '@/api/Onfido';
import { useQuery } from '@tanstack/react-query';

export const useGetOnfidoCheck = (userId?: number) =>
  useQuery({
    queryKey: ['onfidoCheck', userId],
    queryFn: () => GetOnfidoCheck.client(userId as number),
    enabled: !!userId,
    refetchOnWindowFocus: false,
    select: (data) => data?.data,
  });
